import { createAction, createSlice } from '@reduxjs/toolkit';
import { CoreMsgTypes, FirmAssetEntitlementReport } from '@tassat/fred-definitions';

export interface FirmAssetEntitlementsState {
    [key: string]: FirmAssetEntitlementReport;
}

const initialState: FirmAssetEntitlementsState = {};

const initialLoadAction = createAction<{ firmAssetEntitlements: FirmAssetEntitlementsState }>('InitialLoad');
const firmAssetEntitlementReportAction = createAction<FirmAssetEntitlementReport>(CoreMsgTypes.FirmAssetEntitlementReport);

const firmAssetEntitlementsSlice = createSlice({
    name: 'firmAssetEntitlements',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(initialLoadAction, (_state, action) => {
                if (action.payload.firmAssetEntitlements) {
                    return Object.values(action.payload.firmAssetEntitlements)
                        .reduce<FirmAssetEntitlementsState>((state, entitlement) => {
                            state[`${entitlement.FirmId}_${entitlement.Ticker}`] = entitlement;

                            return state;
                        }, {});
                }
            })
            .addCase(firmAssetEntitlementReportAction, (state, action) => {
                const { FirmId, Ticker } = action.payload;
                state[`${FirmId}_${Ticker}`] = action.payload;
            });
    }
});

export default firmAssetEntitlementsSlice.reducer;